module.exports = __webpack_public_path__ + "img/right.337511af.png";